import 'dayjs/locale/fr';

import dayjs, { Dayjs } from 'dayjs';
import type Checkout from 'stripe';

import { StripeCheckoutSession } from '@/core/types/stripe';

dayjs.locale('fr');

class StripeDomain {
  private stripeCheckoutSession: StripeCheckoutSession;
  private userAdless: Dayjs;

  constructor(stripeCheckoutSessionFromApi: StripeCheckoutSession, userAdless: string) {
    this.stripeCheckoutSession = stripeCheckoutSessionFromApi;
    this.userAdless = dayjs(userAdless);
  }

  get stripeCheckoutSessionId(): string {
    return this.stripeCheckoutSession.id;
  }

  get stripeAmountTotalInEuro(): string {
    return (this.stripeCheckoutSession.amount_total * 0.01).toFixed(2);
  }

  get stripeCheckoutSessionStatus(): Checkout.Checkout.Session['status'] {
    return this.stripeCheckoutSession.status;
  }

  get reactivateAdsDate(): { nbDaysWithoutAds: number; reactivateAdsDateInStringFormat: string } {
    const today = dayjs();
    const reactivateAdsDateInStringFormat = this.userAdless.format('DD MMMM YYYY');
    const nbDaysWithoutAds = Math.ceil(this.userAdless.diff(today, 'days', true));

    return { nbDaysWithoutAds, reactivateAdsDateInStringFormat };
  }
}

export default StripeDomain;
